var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { SpinnerIcon } from "./Spinner/SpinnerIcon";
const Container = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
`;
const Content = styled.span `
  padding: 0.5em 0.5em;
`;
const StyledSpinnerIcon = styled(SpinnerIcon) `
  width: 2em;
`;
/**
 * The loading indicator is a simple loading spinner with content next to it.
 */
export const IndeterminateLoadingIndicator = (props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (React.createElement(Container, Object.assign({}, rest),
        React.createElement(StyledSpinnerIcon, null),
        children && React.createElement(Content, null, children)));
};
//# sourceMappingURL=IndeterminateLoadingIndicator.js.map